import React from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import Growl from './growl';

class Growls extends React.Component {
    render () {
        return (
            <div className={['component-growls', this.props.className].join(' ')}>
                <ReactCSSTransitionGroup transitionName="growl" transitionEnterTimeout={400} transitionLeaveTimeout={400}>
                    {
                        this.props.growls.map((growl, i) => {
                            return (
                                <Growl key={i} {...growl} />
                            );
                        })
                    }
                </ReactCSSTransitionGroup>
            </div>
        )
    }
}

export default Growls;



// WEBPACK FOOTER //
// ./web-app/components/growls.jsx